import { useMemo } from 'react';

/**
 * @param {boolean} enabled
 */
export const useSearchSuggestionProvider = (enabled) => {
  return useMemo(() => {
    if (enabled) {
      return async (value) => {
        try {
          const response = await fetch(`/search?q=${value}&t=json`);
          return response.json();
        } catch (error) {
          console.error('Could not get search results', error);
          return {
            list: null,
          };
        }
      };
    }

    return undefined;
  }, [enabled]);
};
